// src/App.tsx

import React, { useState, useEffect } from 'react';
import { Routes, Route, useLocation } from 'react-router-dom';
import Inicio from './Inicio'; 			 
import Concesionarios from './Concesionarios'; 
import Contacto from './Contacto'; 	
import Nosotros from './Nosotros';	 
import { Producto, ItemCarrito } from './types'; 
import Navbar from './Navbar'; 
import Catalogo from './Catalogo'; 
import Footer, { whatsappLink } from './Footer'; 
import DetalleProducto from './DetalleProducto'; 
import AddedToCartModal from './AddedToCartModal'; 
import ResumenCompra from './ResumenCompra'; 
import NotFound from './NotFound';
import SocialLinks from './SocialLinks'; // <--- 1. IMPORTAR

const App: React.FC = () => {
	const [carrito, setCarrito] = useState<ItemCarrito[]>([]);
    const [addedItem, setAddedItem] = useState<Producto | null>(null); 
    
    const { pathname } = useLocation();

    useEffect(() => {
        window.scrollTo(0, 0);
    }, [pathname]);

    useEffect(() => {
        let title = "Bestune Cars Venezuela";
        switch(pathname) {
            case '/': title = "Inicio | Bestune Cars Venezuela"; break;
            case '/catalogo': title = "Catálogo de Vehículos | Bestune Cars"; break;
            case '/concesionarios': title = "Nuestras Sedes | Bestune Cars"; break;
            case '/contacto': title = "Contáctanos | Bestune Cars"; break;
            case '/nosotros': title = "Quiénes Somos | Bestune Cars"; break;
            case '/carrito': title = "Tu Cotización | Bestune Cars"; break;
            case '/links': title = "Enlaces de Interés | Bestune Cars"; break; // <--- TÍTULO PARA LINKS
            default: 
                if(pathname.includes('/detalle')) {
                    title = "Detalle del Vehículo | Bestune Cars";
                }
        }
        document.title = title;
    }, [pathname]);

    const handleAddToCart = (producto: Producto) => {
        const itemExistente = carrito.find(item => item.id === producto.id && item.tipo === producto.tipo);
        if (itemExistente) {
            setCarrito(carrito.map(item => item.id === producto.id && item.tipo === producto.tipo ? { ...item, cantidad: item.cantidad + 1 } : item));
        } else {
            setCarrito([...carrito, { ...producto, cantidad: 1 }]);
        }
        setAddedItem(producto);
    };
    
    const handleRemoveFromCart = (id: number) => {
        setCarrito(carrito.filter(item => item.id !== id));
    };

    const handleWhatsAppClick = () => {
        window.open(whatsappLink, '_blank');
    }

    const totalItems = carrito.reduce((sum, item) => sum + item.cantidad, 0);

    // Lógica para ocultar Navbar y Footer en ciertas rutas
    // Ocultamos Navbar y Footer en '/links' para que se vea como una app independiente
    const isLinksPage = pathname === '/links';

	return (
		<div className="flex flex-col min-h-screen">
            {/* Ocultamos Navbar si estamos en /links */}
			{!isLinksPage && (
                <Navbar 
                    totalItems={totalItems} 
                    onWhatsAppClick={handleWhatsAppClick}
                    carrito={carrito} 
                    onRemoveFromCart={handleRemoveFromCart}
                />
            )}

			<main className="flex-grow">
                <Routes>
                    <Route path="/" element={<Inicio onAddToCart={handleAddToCart} />} />
                    <Route path="/catalogo" element={<Catalogo />} />
                    <Route path="/detalle/:id" element={<DetalleProducto onAddToCart={handleAddToCart} />} />
                    <Route path="/carrito" element={<ResumenCompra carrito={carrito} onRemoveFromCart={handleRemoveFromCart} />} />
                    <Route path="/concesionarios" element={<Concesionarios />} />
                    <Route path="/contacto" element={<Contacto />} />
                    <Route path="/nosotros" element={<Nosotros />} />
                    
                    {/* 2. RUTA NUEVA PARA INSTAGRAM */}
                    <Route path="/links" element={<SocialLinks />} />
                    
                    <Route path="*" element={<NotFound />} />
                </Routes>
			</main>
            
            {/* Ocultamos Footer en detalle y en links */}
            {(pathname.includes('/detalle') || isLinksPage) ? null : <Footer />}
            
            <AddedToCartModal 
                producto={addedItem}
                onClose={() => setAddedItem(null)}
            />
		</div>
	);
};

export default App;